import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetSelect } from 'reactApp/modules/selections/selections.actions';
import { loadUserQuotaRequest } from 'reactApp/modules/userQuota/userQuota.module';
import {
    resetUserQuotaCurrentGroup,
    setMessagesRemove,
    updateUserQuotaCleanerList,
} from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.actions';
import { getNeedGroupsReload } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.selectors';
import { quotaCleanerPageManager } from 'reactApp/ui/QuotaCleanerPage/quotaCleanerPage.toolkit';

export const useCloseCleanerPage = () => {
    const dispatch = useDispatch();
    const needGroupsReload = useSelector(getNeedGroupsReload);

    const onClose = React.useCallback(() => {
        quotaCleanerPageManager.close();
        dispatch(resetUserQuotaCurrentGroup());
        dispatch(resetSelect());
        dispatch(setMessagesRemove({ value: false }));

        if (needGroupsReload) {
            dispatch(loadUserQuotaRequest());
            dispatch(updateUserQuotaCleanerList());
        }
    }, [dispatch, needGroupsReload]);

    return { onClose };
};
